import Validate from './Validate.js';
import { scrollToElement, loadLibrary } from './Util.js';
import {LIB_URL} from '../App';
import { setDateCalendar, setTime, setRangeSelect } from './UI.js';
import {
    closePersonalForm,
    savePersonalCheckingPhone,
    userSetEmail,
    checkCurrentPhoneValue,
    /*formatPhone*/
} from "./PagePersonal";
import { showSmsSend, regAfterCheckingPhone, smsRrequest } from "./PageAuth";
import { pagePersonalDataFormPhone } from "./PagePersonalDataForm";
import { finishTestForm } from "./FinishTestForm";
import { quickRegistrationSmsRrequest, quickRegAfterCheckingPhone } from './QuickRegistration';

export default class Form {
    constructor(form) {
        this.maskPhoneInit()
        this.validateObj = '';
        this.$form = $(form);

        if(!this.$form.length) return;

        this.$btn = this.$form.find('.js-submit');
        this.recaptcha;
        window.isSendForm = true
        this.popLabels();
        this.validate();
        this.initRecaptcha();
        loadLibrary(LIB_URL.JQ_FORM, $.proxy(this.bindSubmit, this));
        this.bindClose();
        this.bindResetSuccess();
        this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        this.filterPhone();
        this.filterDate();
        this.filterTime();
        this.spamCheck();
        this.rangeSelect();
    }



    rangeSelect() {
        setRangeSelect(this.$form.find('.js-range-from'), this.$form.find('.js-range-to'));
    }

    // Валидация
    validate() {
        this.validateObj = new Validate(this.$form);
    }

    maskPhoneInit(){
        if($('[data-mask-phone]').length){
            loadLibrary('/js/jquery.maskedinput.min.js', ()=>{
                $('[data-mask-phone]').mask('+7 (999) 999-99-99')
                $('[data-mask-phone]').parents('.js-input-wrap').removeClass('_focused-always')
            });
        }
    }

    // Инициализируем рекапчу
    initRecaptcha() {
        const $container = this.$form.find('.js-recaptcha');

        if (!$container.length) {
            return false;
        }

        this.recaptcha = this.genRecaptcha($container);
        //console.log('Инициализируем рекапчу------', this.recaptcha);

        /*if ($container.data('type') && $container.data('type') === 'invisible') {
            this.recaptcha = grecaptcha.render($container.attr('id'), {
                'sitekey' : $container.data('sitekey'),
                'size': 'invisible',
                'callback' : (recaptchaVal) => {
                    $container.removeClass('_error _notvalidated');
                    App.currentRecaptcha = recaptchaVal;
                    //this.$form.find('.js-submit').trigger('click');
                    this.sendForm();
                }
            });
        } else {
            this.recaptcha = grecaptcha.render($container.attr('id'), {
                'sitekey': $container.data('sitekey'),
                'callback': (recaptchaVal) => {
                    $container.removeClass('_error _notvalidated');
                    App.currentRecaptcha = recaptchaVal;
                },
                'error-callback': () => {
                    // Ошибка на стороне рекапчи
                    this.$form
                        .removeClass('_success')
                        .addClass('_error');

                    if (this.recaptcha) {
                        grecaptcha.reset(this.recaptcha);
                    }

                    console.log('recaptcha error');
                }
            });
        }*/
    }

    genRecaptcha($container) {
        /*console.log('grecaptcha----', grecaptcha, 'id----', $container.attr('id'));
        console.log('this.recaptcha----', this.recaptcha);*/

        /*grecaptcha.reset(this.recaptcha);*/



        return grecaptcha.render($container.attr('id'), {
            'sitekey': $container.data('sitekey'),
            'size': $container.data('type') ? $container.data('type') : '',
            'callback': (recaptchaVal) => {
                /*console.log('callback, текущая катча----', this.recaptcha);*/
                $container.removeClass('_error _notvalidated');

                App.currentRecaptcha = recaptchaVal;

                if ($container.data('type') === 'invisible') {
                    if(window.isSendForm) {
                        window.isSendForm = false;
                        this.sendForm();
                        setTimeout(()=>{
                            window.isSendForm = true;
                        }, 200)
                    }
                }
            },
            'error-callback': () => {
                // Ошибка на стороне рекапчи
                /*console.log('Ошибка на стороне рекапчи');*/

                this.$form
                    .removeClass('_success')
                    .addClass('_error');

                if (this.recaptcha) {
                    grecaptcha.reset(this.recaptcha);
                    /*console.log('Ошибка рекапчи-', this.recaptcha);*/
                }

                console.log('Recaptcha error callback');
            }
        });
    }

    // Событие отправки
    bindSubmit() {
        this.$form.find('button').on('click', function () {
            $(this).blur();
        });

        this.$form.on('submit', (e) => {
            if (this.$form.find('.js-recaptcha').data('type') === 'invisible') {
                grecaptcha.execute(this.recaptcha);
                /*console.log(this.recaptcha);*/
            }
            if (!this.validateObj.validateAllFields()) {
                e.preventDefault();

                if (!$(e.target).closest('.js-common-popup').length) {
                    //scrollToElement($('[data-required]._error').first());
                    //scrollToElement($('.js-input._error').first());
                    scrollToElement($('._error').first());
                }
            } else {
                // если это форма ЛК, проверяем изменил пользователь номер телефона в форме или нет
                if (this.$form.is('.js-personal-data-form,.js-page-personal-data-form') && !this.$form.is('.phone-is-accept')) {
                    checkCurrentPhoneValue(this.$form);
                }

                if ($('.js-registration-speciality').length > 0 && $('.js-registration-speciality').val()) {
                    let specialityValue = $('.js-registration-speciality').val();
                    window.localStorage.setItem('speciality', $('.js-registration-speciality option[value="' + specialityValue + '"]').text());
                }

                // если это форма, где надо подветрждать телефон  и телефон указан, то отправляем код и показываем попап для ввода СМС
                if (this.$form.is('[data-sms-confirmed-form]') &&
                    !this.$form.is('.phone-is-accept') &&
                    this.$form.find('.js-sms-phone-field').val() !== '') {

                    smsRrequest();
                    $('[data-popup="confirmPhone"]').trigger('click');
                    e.preventDefault();
                } else if (this.$form.is('[data-quick-reg-sms-confirmed-form]') &&
                    !this.$form.is('.phone-is-accept') &&
                    this.$form.find('.js-sms-phone-field').val() !== '') {

                    quickRegistrationSmsRrequest();
                    e.preventDefault();
                } else if (this.$form.data('not-ajax') === undefined) {
                    if(window.isSendForm){
                        window.isSendForm = false;
                        this.sendForm();
                        setTimeout(()=>{
                            window.isSendForm = true;
                        }, 200)
                    }
                    e.preventDefault();
				} else if (App.gtmFormSubmit) {
                    App.gtmFormSubmit(this.$form[0]);
                }
            }

            // Запускаем проверку рекапчи
            //grecaptcha.execute(this.recaptcha);
        });
    }



    // Отправка
    sendForm() {
        if (!this.validateObj.validateAllFields()) {
            scrollToElement($('._error').first());
            return false;
        }
        this.$btn.addClass('_disabled');
        this.$form.ajaxSubmit({
            url: this.$form.attr('action'),
            dataType: 'json',
            // data: this.$form.serialize(),
            type: this.$form.attr('method') || 'GET',
            cache: false,
            success: (response) => {
                if(this.$form.hasClass('vacancy-form') && response.status === 200){
                    $('[data-vacancy-popup]').find('.simple-form').remove()
                    if(response.responseText.includes('simple-form__success')){
                        $('[data-vacancy-popup]').find('.vacancy__popup-form').empty()
                        $('[data-vacancy-popup]').addClass('success')
                        $('[data-vacancy-popup]').find('.vacancy__popup-form').append(response.responseText)
                    }
                    return;
                }
                if (!response.success) {
                    // Ошибка на сервере
                    this.$form
                        .removeClass('_form-success')
                        .addClass('_form-error _form-message');

                    this.$form.find('.ajax-error').html(response.message);
                    scrollToElement($('.ajax-error').first());

                    let $input = this.$form.find('.js-mask-phone');
                    let $label = $input.closest('.js-input-wrap').find('[data-label]');
                    if ($input.is('[data-required]') && $input.val() == 0) {
                        $input.addClass('_error').removeClass('_filled')
                            .parent().addClass('_error');
                        $label.text($label.text().length > 0 ? $label.text() : window.validateMessages.required);
                    }

                    // Разблокируем кнопку
                    this.$btn.removeClass('_disabled');
                    //this.$btn.removeAttr('disabled');

                    this.$form.trigger('form:error', response);
                } else {

                    if (this.$form.is('.js-required-email-form')) {
                        userSetEmail();
                    }

                    // Успех!
                    if (!this.$form.is('.js-order-login-form')) {
                        this.resetForm();
                    }

                    if (this.$form.is('.js-password-form') && $('.js-password-success').length > 0) {
                        $('.js-password-success').addClass('_active');
                        setTimeout(() => {
                            $('.js-password-success').removeClass('_active');
                        }, 3000);
                    }

                    this.$form
                        .removeClass('_form-error')
                        .addClass('_form-success _form-message')
                        .find('.ajax-error').html('');

                    if (!this.$form.is('[data-no-resettable]') && !this.$btn.closest('.js-common-popup').length) {
                        scrollToElement(this.$form);
                    }

                    /** Коллбеки для разных форм при успенной отправке */

                    /* Личный кабинет */
                    if (this.$form.is('[data-personal]')) {
                        closePersonalForm(this.$form);
                    }

                    /* Восстановление пароля по sms */
                    if (this.$form.is('.js-form-sms-request')) {
                        showSmsSend();
                    }

                    /* Регистрация и ЛК: проверка номера телефона */
                    if (this.$form.is('.js-form-sms-send')) {
                        $('[data-sms-confirmed-form]').addClass('phone-is-accept');
                        regAfterCheckingPhone(this.$form);
                        savePersonalCheckingPhone(this.$form);
                        pagePersonalDataFormPhone(this.$form);
                    }

                    if (this.$form.is('.js-form-quick-reg-sms-send')) {
                        $('[data-quick-reg-sms-confirmed-form]').addClass('phone-is-accept');
                        quickRegAfterCheckingPhone(this.$form);
                    }

                    if (this.$form.is('.js-product-available')) {
                        let form = this.$form;
                        let productId = form.attr('data-product-message');
                        let btn = $('[data-product-id="' + productId + '"]').find('.js-message-me');
                        let btnSendText = btn.data('send-text');

                        btn.addClass('_disabled').text(btnSendText);
                    }

                    if (this.$form.is('.js-form-test')) {
                        finishTestForm(this.$form);
                    }

                    if (App.gtmFormSubmit) {
                        App.gtmFormSubmit(this.$form[0]);
                    }
                    if (this.$form.is('.js-quick-registration-form, .js-quick-auth-phone-form, .js-quick-auth-email-form')) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 600)
                    } else if (this.$form.is('.js-quick-registration-step1')) {
                        window.location.href = '/invite/?action=confirm&id=' + response.data.userId;
                    } else if (this.$form.is('.js-quick-registration-step2')) {
                        window.location.href = '/doctor';
                    } else if (response.redirect) {
                        window.location.href = response.redirect;
                    }

                    if (this.$form.is('.js-offline-event')) {
                        App.H.find('.js-offline-event-btn').addClass('hidden');
                    }

                    this.$form.trigger('form:success', response);
                }

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);

            },
            error: (response) => {
                if(this.$form.hasClass('vacancy-form') && response.status === 200){
                    $('[data-vacancy-popup]').find('.simple-form').remove()
                    $('[data-vacancy-popup]').find('.vacancy__popup-form').empty()
                    $('[data-vacancy-popup]').addClass('success')
                    if(this.$form.find('input[name="vacancy-id"]').val()){
                        $('[data-vacancy-popup]').find('.vacancy__popup-form').append(`<div class="simple-form__success" data-form-simple-success><div class="simple-form__success-title">Спасибо за интерес <br>к нашей компании </div><div class="simple-form__success-text">Мы внимательно изучим ваше резюме и свяжемся с вами в течение 2 недель, если ваш опыт и навыки будут подходить для данной вакансии.</div><div class="simple-form__success-text" style="margin-top: 24px;"><b><i>С уважением, отдел привлечения талантов</i></b></div></div>`)
                    } else{
                        $('[data-vacancy-popup]').find('.vacancy__popup-form').append(`<div class="simple-form__success" data-form-simple-success><div class="simple-form__success-title">Спасибо за интерес <br>к нашей компании </div><div class="simple-form__success-text">Мы внимательно изучим ваше резюме и свяжемся с вами при появлении подходящей вакансии.</div><div class="simple-form__success-text" style="margin-top: 24px;"><b><i>С уважением, отдел привлечения талантов</i></b></div></div>`)
                    }
                    return;

                }
                // Ошибка отправки
                this.$form
                    .removeClass('_form-success')
                    .addClass('_form-error _form-message');

                // Разблокируем кнопку
                this.$btn.removeClass('_disabled');
                //this.$btn.removeAttr('disabled');

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);

                this.$form.trigger('form:error', {message: 'Ошибка отправки формы'});
            }
        });
    }



    // Закрытие формы
    bindClose() {
        App.H
            .find('.js-form-ok')
            .on('click', function (e) {
                e.preventDefault();
                this.$form.removeClass('_form-success _form-error _form-message');
            });
    }



    // Очистить форму
    bindResetSuccess() {
        App.H
            .find('.js-form-reset')
            .on('click', (e) => {
                e.preventDefault();

                //this.resetForm();
                this.$form.removeClass('_form-success _form-error _form-message');

                /*this.$form.removeClass('_form-success _form-error _form-message');
                this.$btn.removeAttr('disabled');
                this.$btn.removeClass('_disabled');*/
            });
    }



    // Загрузка файла
    fileUpload() {
        this.$form
            .find('.js-upload')
            .on('change', function () {
                const $input = $(this);
                const $label = $input.closest('.input-wrap').find('.js-upload-label');
                const $ext = $input.closest('.input-wrap').find('.js-upload-ext');
                let $preview = $input.closest('.input-wrap').find('.js-upload-preview');
                const val = $input.val();
                let fileName, ext;

                if (val.length) {
                    if($('[data-resume-file-field]').length){
                        $('[data-resume-file-field]').removeClass('field-error')
                    }
                    fileName = val.split('\\').pop() || '';
                    ext = val.split('.').pop() || '';
                    $label.text(fileName);
                    $ext.text(ext);
                    $input.addClass('_active');

                    if ($input[0].files && $input[0].files[0] && $preview.length) {
                        var reader = new FileReader();

                        reader.onload = function (e) {
                            $preview.attr('src', e.target.result);
                        };

                        reader.readAsDataURL($input[0].files[0]);
                    }
                } else {
                    $label.text($label.data('text'));
                    $input.removeClass('_active');
                }
            });


        this.$form
            .find('.js-upload-clear')
            .on('click', function () {
                $(this).closest('.input-wrap').find('.js-upload').val('').change();
            });
    }



    // Календарь даты DatePicker
    filterDate() {
        setDateCalendar();
    }



    // Календарь даты DatePicker
    filterTime() {
        setTime();
    }


    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find('[data-phone]').on('input', function () {
            const val = $(this).val().replace(/[^0-9\s()+-]/g, '');
            $(this).val(val);
            $(this).trigger('change');
        });
    }



    // Сброс формы
    resetForm() {
        if (this.$form.is('[data-no-resettable]')) {
            this.$form.find('.js-submit').removeClass('_disabled').removeAttr('disabled');

            return false;
        }

        this.$form[0].reset();

        this.$form
            .find('.js-upload')
            .val('')
            .change()
            .siblings('[data-label]')
            .text('');

        // this.$form.removeClass('_success _error');

        this.$form.removeClass('_form-success _form-error _form-message');
        this.$btn.removeAttr('disabled');
        this.$btn.removeClass('_disabled');


        this.$form
            .find('[data-required]')
            .not(':checkbox')
            .addClass('_notvalidated')
            .removeClass('_error');

        this.$form
            .find(':checkbox[data-required]')
            .not(':checked')
            .addClass('_notvalidated');

        /*this.$form
            .find('.js-submit')
            .attr('disabled', true);*/

        this.$form
            .find('.js-input-wrap')
            .removeClass('_filled')
            .removeClass('_focused');

        this.$form
            .find('.js-dropdown')
            .trigger('dropdown:reset');

        if (this.recaptcha) {
            /*console.log('reset captcthta-------------');*/
            grecaptcha.reset(this.recaptcha);
            /*console.log(this.recaptcha);*/
        }

        console.log('test redet nbtn');
    }



    // Подсказки для инпутов
    popLabels() {
        this.$form
            .find('input.js-input, textarea.js-input, select.js-input')
            .on('input blur init', function (e) {
                if($(this).val() !== null){
                    const val = $(this).val().trim();
                    //if (!val.length || val == '+7() --') {
                    if (!val.length && !$(this).is('.js-mask-phone')) {
                        $(this).closest('.js-input-wrap').removeClass('_filled');
                    } else {
                        $(this).closest('.js-input-wrap').addClass('_filled');
                    }
                }
                if (e.type == 'blur') {
                    $(this).closest('.js-input-wrap').removeClass('_focused');
                }
            })
            .on('focus', function () {
                $(this).closest('.js-input-wrap').addClass('_focused');
            })
            .trigger('init');
    }



    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find('[type="text"], [type="email"], [type="tel"], [type="password"]')
            .not('.js-sms-code')
            .attr('autocomplete', 'new-password')
            .filter('.js-mask-phone')
            .attr('autocomplete', 'tel');

        this.$form
            .find('.js-promocode-input')
            .attr('autocomplete', 'off');
    }



    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }



    // Защита от спама (если нет рекапчи)
    spamCheck() {
        App.secondsOnPage = 0;

        // Проверка phantomJS
        let isBot = function () {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true;  //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }


        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        let name = this.$form.data('name');
        this.$form.append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            App.secondsOnPage++;
            $('.js-input-seconds').val(App.secondsOnPage);
        }, 1000);
    }
}

function loadCaptchaScript($forms) {
    if ($forms.length == 0) return;

    const scriptSrc = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaOnLoad&render=explicit';

    // Возможность генерировать кастомные события (для IE). Нужно для рекапчи
    // Create and trigger custom events
    if (typeof window.CustomEvent != "function") {
        window.CustomEvent = function (event, params) {
            params = params || {
                    bubbles: false,
                    cancelable: false,
                    detail: undefined
                };

            var evt = document.createEvent('CustomEvent');

            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }

    window.grecaptchaOnLoad = function() {
        var event = new CustomEvent('grecaptchaLoaded');
        window.dispatchEvent(event);
    };

    //console.log('loadCaptchaScript');

    $.getScript(scriptSrc)
        .done(function() {
            /* script, textStatus */
            App.H.addClass('_recaptcha-loaded');

            App.W.on('grecaptchaLoaded', function () {
                $forms.each(function () {
                    if (!$(this).is('._init')) {
                        new Form(this);
                        $(this).addClass('_init');
                    }
                });
            });
        })
        .fail(function() {
            /* jqxhr, settings, exception  */
            console.log('fail ajax');
        });
}

export function loadCaptchaForms($form) {
    if (App.H.is('._recaptcha-loaded') && !$form.is('._init')) {
        new Form($form[0]);
        $form.addClass('_init');
    } else {
        loadCaptchaScript($form);
    }
}

/*
App.W.on('grecaptchaLoaded', function () {
    $('.js-form').each(function () {
        new Form(this);
    });
});*/

loadCaptchaScript($('.js-form').filter(formDom => $(formDom).closest('.js-common-popup').length == 0));

/*$('.js-form').on('click', function (e) {
    initForm($(this), e);

    e.preventDefault();
});*/


/*
export function initForm($form, event) {
    console.log('click form', event.pageX, event.pageY);
    /!*new Form(this);*!/
    $form.off('click');
    loadCaptchaScript($form, event.pageX, event.pageY);
}
*/

//  Для формы фото + чекбокс согласия для оффлайн мероприятий
$('.js-offline-event').each(function() {
    let $file = $(this).find('.js-upload');
    let $checkbox = $(this).find('.js-input[type="checkbox"]');
    changeRequiredAttr($file, $checkbox);

    $file.change(function() {
        changeRequiredAttr($file, $checkbox);
    });
});

function changeRequiredAttr(input, checkbox) {
    if (!input.val().length) {
        checkbox.removeClass('_error').removeAttr('data-required');
    } else {
        checkbox.attr('data-required', true);
    }
}
